export default "__VITE_ASSET__c1128d43__"